export default "__VITE_ASSET__DzN_dtjF__"